var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('search-nav-start-end',{attrs:{"label":"회의일"},model:{value:(_vm.nav.inputA_4),callback:function ($$v) {_vm.$set(_vm.nav, "inputA_4", $$v)},expression:"nav.inputA_4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }